// !--- Trryst Confidential. Please do not share or distribute without approval from Trryst (CSuite Ltd.)
import * as React from "react";
import SimpleNotificationCard from "blocks/views/Notifications/foundations/SimpleNotificationCard";
import { getS3ImageWrapper } from "@app21/core";

const SuiteAddedOrganization = ({ notification, viewContext, index }) => {
  const { payload } = notification;

  const data = {
    message: `Suite ${payload?.addedSuiteFullName} has been added to ${
      payload?.organizationFullName || "Organization"
    }`,
    avatar: getS3ImageWrapper(
      payload?.addedSuiteImage,
      "suite",
      payload?.addedSuiteFullName
    ),
    subHeader: notification.createdAt,
  };
  return (
    <SimpleNotificationCard
      data={data}
      notification={notification}
      viewContext={viewContext}
      index={index}
    />
  );
};

export default SuiteAddedOrganization;
